import { FC, ReactNode } from "react"
import { Box } from "@strapi/design-system"

interface EmptyPageProps {
  children?: ReactNode
}

export const EmptyPage: FC<EmptyPageProps> = ({ children }) => {
  return (
    <Box
      background="neutral100"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  )
}
